import { apiLoja } from '@/services/api';
import * as ROUTES from '@/routes/routes';
import { showAlert } from '@/store/actions/theme';
import { push } from 'connected-react-router';
import {
  PROGRESSIVE_DISCOUNTS_SET,
  PROGRESSIVE_DISCOUNT_EDIT_SET,
  PROGRESSIVE_DISCOUNT_LOADING,
  PROGRESSIVE_DISCOUNT_LOADED,
  PROGRESSIVE_DISCOUNT_CLEAR,
  PROGRESSIVE_DISCOUNT_TYPES_SET,
  PROGRESSIVE_DISCOUNT_TYPES_LOADING,
  PROGRESSIVE_DISCOUNT_TYPES_LOADED,
} from '../actionTypes';

export const setProgressiveDiscounts = (discounts) => ({
  type: PROGRESSIVE_DISCOUNTS_SET,
  payload: discounts,
});

export const setProgressiveDiscountEdit = (discount) => ({
  type: PROGRESSIVE_DISCOUNT_EDIT_SET,
  payload: discount,
});

export const loadingProgressiveDiscount = () => ({
  type: PROGRESSIVE_DISCOUNT_LOADING,
});

export const loadedProgressiveDiscount = () => ({
  type: PROGRESSIVE_DISCOUNT_LOADED,
});

export const clearProgressiveDiscount = () => ({
  type: PROGRESSIVE_DISCOUNT_CLEAR,
});

export const setProgressiveDiscountTypes = (types) => ({
  type: PROGRESSIVE_DISCOUNT_TYPES_SET,
  payload: types,
});

export const loadingProgressiveDiscountTypes = () => ({
  type: PROGRESSIVE_DISCOUNT_TYPES_LOADING,
});

export const loadedProgressiveDiscountTypes = () => ({
  type: PROGRESSIVE_DISCOUNT_TYPES_LOADED,
});

// Fetch list of discounts
export const fetchProgressiveDiscounts = () => {
  return (dispatch, getState) => {
    dispatch(loadingProgressiveDiscount());
    const idFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .get(`/DescontoProgressivo/Franqueadora/${idFranqueadora}`)
      .then((res) => {
        dispatch(setProgressiveDiscounts(res.data));
        dispatch(loadedProgressiveDiscount());
      })
      .catch((error) => {
        console.log('Error loading progressive discounts', error);
        dispatch(loadedProgressiveDiscount());
      });
  };
};

// Add discount
export const addProgressiveDiscount = (discount) => {
  return (dispatch, getState) => {
    dispatch(loadingProgressiveDiscount());
    const idFranqueadora = discount.IdFranqueadora || getIdFranqueadoraFromState(getState);

    const payload = {
      ...discount,
      IdFranqueadora: Number(idFranqueadora),
    };

    apiLoja
      .post(`/DescontoProgressivo`, payload)
      .then((res) => {
        dispatch(setProgressiveDiscountEdit(res.data));
        dispatch(loadedProgressiveDiscount());
        dispatch(push(ROUTES.PROGRESSIVE_DISCOUNTS));
        dispatch(
          showAlert({
            type: 'success',
            message: 'Desconto Progressivo criado com sucesso!',
            time: 3000,
          })
        );
      })
      .catch((error) => {
        console.log('Error creating progressive discount', error);
        dispatch(loadedProgressiveDiscount());
        dispatch(
          showAlert({
            type: 'danger',
            message: 'Erro ao criar o Desconto Progressivo.',
            time: 4000,
          })
        );
      });
  };
};

// Edit discount
export const editProgressiveDiscount = (discount) => {
  return (dispatch, getState) => {
    dispatch(loadingProgressiveDiscount());
    const idFranqueadora = discount.IdFranqueadora || getIdFranqueadoraFromState(getState);

    const payload = {
      ...discount,
      IdFranqueadora: Number(idFranqueadora),
    };

    apiLoja
      .put(`/DescontoProgressivo/${discount.IdDescontoProgressivo}`, payload)
      .then((res) => {
        dispatch(setProgressiveDiscountEdit(res.data));
        dispatch(loadedProgressiveDiscount());
        dispatch(
          showAlert({
            type: 'success',
            message: 'Desconto Progressivo atualizado com sucesso!',
            time: 3000,
          })
        );
      })
      .catch((error) => {
        console.log('Error updating progressive discount', error);
        dispatch(loadedProgressiveDiscount());
        dispatch(
          showAlert({
            type: 'danger',
            message: 'Erro ao atualizar o Desconto Progressivo.',
            time: 4000,
          })
        );
      });
  };
};

const getIdFranqueadoraFromState = (getState) => {
  const state = getState();
  return state.user && state.user.user ? state.user.user.IdFranqueadora : null;
};

// Fetch discount by ID
export const fetchProgressiveDiscountById = (id) => {
  return (dispatch, getState) => {
    dispatch(loadingProgressiveDiscount());
    const idFranqueadora = getIdFranqueadoraFromState(getState);

    apiLoja
      .get(`/DescontoProgressivo/${id}/Franqueadora/${idFranqueadora}`)
      .then((res) => {
        dispatch(setProgressiveDiscountEdit(res.data));
        dispatch(loadedProgressiveDiscount());
      })
      .catch((error) => {
        console.log('Error loading progressive discount details', error);
        dispatch(loadedProgressiveDiscount());
      });
  };
};

// Fetch types of discounts
export const fetchProgressiveDiscountTypes = () => {
  return (dispatch) => {
    dispatch(loadingProgressiveDiscountTypes());
    apiLoja
      .get('/DescontoProgressivo/Tipos')
      .then((res) => {
        dispatch(setProgressiveDiscountTypes(res.data));
        dispatch(loadedProgressiveDiscountTypes());
      })
      .catch((error) => {
        console.log('Error fetching progressive discount types', error);
        dispatch(loadedProgressiveDiscountTypes());
      });
  };
};
